import { getCallConferenceAgent, getCallSessionAgentUserId, getCallTransferAgent } from "../api";
import { callAPi } from "../CallService";
import { getAgentPhoneForCallingKrmId, getSessionUserId } from "../helpers";

export const getApiParams = (callFlow, agent) => {
  const data = {
    user_id: getCallSessionAgentUserId(),
    cm_access_key: null,
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    uuid: callFlow.ticker.firstCallAnswerEvent["unique_id"],
    ivr_display_number: callFlow.state.callEvent["knowlarity_number"],
    to: getAgentPhoneForCallingKrmId(agent),
    queue_id: callFlow.state.callEvent["variable_cc_queue"]
      ? callFlow.state.callEvent["variable_cc_queue"]
      : null,
  };
  return data;
};

export const ibd_cc = {
  CALL_ACTIONS: {
    QUEUE_TRANSFER_CALL: async (callFlow, queue) => {
      const data = {
        freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
        uuid: callFlow.state.callEvent["uuid"],
        type: "queue_transfer",
        args: queue["q_uuid"],
      };
      return await callAPi("/newsr/sr_callcenter/transfer_call/", "POST", data);
    },
    TRANSFER_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "att_xfer";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_CALL: async (callFlow, agent) => {

      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "complete";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },

    CONFERENCE_CALL_CANCEL: async (callFlow, agent) => {
      const isSessionAgentSip = callFlow.state.session_agent.sip_url_flag;
      const isLegCAgentSip = (getCallTransferAgent()?.sip_url_flag || getCallConferenceAgent()?.sip_url_flag);

      const newToParam = 
      (isSessionAgentSip && isLegCAgentSip) 
      ? agent?.phone 
      : (isSessionAgentSip && !isLegCAgentSip) 
      ? getAgentPhoneForCallingKrmId(agent) 
      : (!isSessionAgentSip && isLegCAgentSip) 
      ? (getCallTransferAgent()?.phone || getCallConferenceAgent()?.phone)
      : (!isSessionAgentSip && !isLegCAgentSip) 
      ? getAgentPhoneForCallingKrmId(agent) 
      : '';

      const newUuidParam = 
      (isSessionAgentSip && isLegCAgentSip) 
      ? (sessionStorage.getItem('legcuuid') || callFlow.ticker.eventsMap["ORIGINATE"]["unique_id"])
      : (!isSessionAgentSip && isLegCAgentSip) 
      ? (sessionStorage.getItem('legcuuid') || callFlow.ticker.eventsMap["ORIGINATE"]["unique_id"])
      : (isSessionAgentSip && !isLegCAgentSip) 
      ? callFlow.ticker.firstCallAnswerEvent["unique_id"] 
      : (!isSessionAgentSip && !isLegCAgentSip) 
      ? callFlow.ticker.firstCallAnswerEvent["unique_id"]
      : '';

      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "cancel";
      data1["to"] = newToParam;
      data1["uuid"] = newUuidParam;
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_HOLD: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "hold";
      data1["uuid"] = (sessionStorage.getItem('legcuuid') || callFlow.ticker.firstCallAnswerEvent["unique_id"]);

      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_UNHOLD: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "unhold";
      data1["uuid"] = (sessionStorage.getItem('legcuuid') || callFlow.ticker.firstCallAnswerEvent["unique_id"]);
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },

    AGENT_LIST_API: async (callFlow, params) => {
      return await callAPi("/newsr/api/v1/warm_call_agents/", "GET", params);
    },

    QUEUE_LIST_API: async (callFlow) => {
      const data = { user_id: getSessionUserId() };
      const response = await callAPi(
        "/newsr/sr_callcenter/queue_init_info/",
        "GET",
        data
      );
      return response;
    },
  },
};
